import { render, staticRenderFns } from "./TextareaInputAutoHeight.vue?vue&type=template&id=9ef95ae4&"
import script from "./TextareaInputAutoHeight.vue?vue&type=script&lang=ts&"
export * from "./TextareaInputAutoHeight.vue?vue&type=script&lang=ts&"
import style0 from "./TextareaInputAutoHeight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports